import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CurriculumAnalytics from './view';

class CurriculumAnalyticsContainer extends PureComponent {
  render() {
    const { activeTab, programId } = this.props;
    return <CurriculumAnalytics activeTab={activeTab} programId={programId} />;
  }
}

CurriculumAnalyticsContainer.propTypes = {
  activeTab: PropTypes.string,
  programId: PropTypes.string,
};

CurriculumAnalyticsContainer.defaultProps = {
  activeTab: 'programs',
  programId: null,
};

export default connect((store, { match: { params: { activeTab, programId } } }) => ({
  activeTab,
  programId,
}))(CurriculumAnalyticsContainer);
